module.exports = __webpack_public_path__ + "media/images/icon_danger-1c2963ee3467352a1681c22d857c6de7.png";